import { FieldPath } from 'react-hook-form'

import { GanttFormValues } from '@gantt/components/GanttCreateOrEdit'
import {
  AXIS_X_FORM_FIELD_KEYS,
  AXIS_Y_FORM_FIELD_KEYS,
  GENERAL_FORM_FIELD_KEYS,
  MAIN_OBJECT_FORM_FIELD_KEYS,
  PARAMETERS_FORM_FIELD_KEYS,
} from '@gantt/constants/keys'

export const EMPTY_COMMAND_FORM = [
  {
    httpMethod: null,
    type: null,
    name: null,
    sourceType: null,
    sourceCommand: null,
    parameters: [],
    body: [],
  },
]

export const FORM_STEP_FIELDS: Record<number, Array<FieldPath<GanttFormValues>>> = {
  0: GENERAL_FORM_FIELD_KEYS,
  1: AXIS_Y_FORM_FIELD_KEYS,
  2: AXIS_X_FORM_FIELD_KEYS,
  3: MAIN_OBJECT_FORM_FIELD_KEYS,
  4: PARAMETERS_FORM_FIELD_KEYS,
}

export const GANTT_MAX_ROW_HEIGHT = 100
export const GANTT_BAR_MAX_TITLES_COUNT = 3
export const GANTT_RESOURCE_COLUMN_MAX_FIELDS_COUNT = 3
